module.exports = __webpack_public_path__ + "media/site/images/jedziemyrazem-screen@2x-6a4ea45cf20b6635db9544fd39227d3d.jpg";